import { render, staticRenderFns } from "./user-details.view.vue?vue&type=template&id=55ecc264&scoped=true&"
import script from "./user-details.view.ts?vue&type=script&lang=ts&"
export * from "./user-details.view.ts?vue&type=script&lang=ts&"
import style0 from "./user-details.view.scss?vue&type=style&index=0&id=55ecc264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ecc264",
  null
  
)

export default component.exports